<template>
    <div class="MemberMailList">
        <div class="mail_title">
            <h2>信件訊息</h2>
        </div>
        <div class="create_maintain">
            <router-link  class="btn send_div" :to="{ name: 'MemberHome' }">
                返回
            </router-link>
        </div>
        <div class="maintain_content">
            <div class="div_table">
                <table class="table" ref="oTable">
                    <thead>
                        <tr>
                            <th>項次</th>
                            <th>收件人</th>
                            <th>收件人電話</th>
                            <th>信件類別</th>
                            <th>收件日期</th>
                            <th>郵件編號</th>
                            <th>貨運公司</th>
                            <th>狀態</th>
                            <th>觀看照片</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in tenant_mailmanage_list" :key="item.id">
                            <td>
                                {{ item.order }}
                            </td>
                            <td>
                                {{ item.recipient_name }}
                            </td>
                            <td>
                                {{ item.recipient_phone }}
                            </td>
                            <td>
                                {{ item.recipient_type }}
                            </td>
                            <td>
                                {{ item.receiving_time }}
                            </td>
                            <td>
                                {{ item.mail_no }}
                            </td>
                            <td>
                                {{ item.shipping_company }}
                            </td>
                            <td :style="mail_release_style[item.mail_release]">
                                {{ mail_release_status[item.mail_release] }}
                            </td>
                            <td>
                                <button class="btn btn_mystyle" @click="looK_photo(item.id)">
                                    觀看
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="my_model" v-show="model_switch" @click="model_switch = !model_switch">
            <div class="my_model_content">
                <img class="model_img" :src="img_src">
            </div>
        </div>
    </div>
</template>

<script>
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "@/assets/css/member/memberMail/memberMailList.css";

export default {
    name: "MemberMailList",
    data: function () {
		return {
            mail_release_status: ['未領', '已領'],
            mail_release_style: ['color:red;', 'color:blue;'],
            tenant_mailmanage_list: [],
            model_switch: false,
            img_src: ''
		};
	},
    beforeMount: function () {
        if (this.$route.name == 'MemberHome' && !localStorage.getItem('house_number') && this.$store.state.house_number == null) {
            this.$router.push({ name: 'Login' });
        } else {
            const getData = new FormData();
            getData.append('CMD' , 'FrontMemberHomeMemberMailList');
            if (localStorage.getItem('house_number') != null) {
                getData.append('house_number' , localStorage.getItem('house_number'));
            }
            getData.append('type' ,'getData');
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
            .then(response => {
                // console.log(response);
                if (response.data.result == false) {
                    alert(response.data.msg);
                    console.log(response.data.error);
                } else {
                    this.tenant_mailmanage_list = response.data.tenant_mailmanage_list;
                    this.$nextTick(() =>{ //請求成功的回調使用
                        $(this.$refs.oTable).DataTable({
                            searching: false, //搜尋功能, 預設是開啟
                            paging: true, //分頁功能, 預設是開啟
                            ordering: false, //排序功能, 預設是開啟
                            lengthMenu: [10, 20],
                            language: {
                                processing: "處理中...",
                                loadingRecords: "載入中...",
                                lengthMenu: "一頁顯示 _MENU_ 筆",
                                zeroRecords: "沒有數據....",
                                info: "第 _START_ ~ _END_ 筆，共 _TOTAL_ 筆",
                                infoEmpty: "",
                                infoFiltered: "(從 _MAX_ 項結果中過濾)",
                                infoPostFix: "",
                                search: "搜尋:",
                                paginate: {
                                    first: "第一頁",
                                    previous: "上一頁",
                                    next: "下一頁",
                                    last: "最後一頁"
                                }
                            }
                        });
                    })
                }
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    methods: {
        looK_photo (id) {
            console.log(id);
            // this.model_switch = true;
            const getPhoto = new FormData();
            getPhoto.append('CMD', 'FrontMemberHomeMemberMailGetPhoto');
            getPhoto.append('type','getPhoto');
            getPhoto.append('id', id);
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getPhoto)
            .then(response => {
                // console.log(response);
                const get_img = response.data;
                if (get_img.result == true) {
                    this.model_switch = true;
                    const oSrc = JSON.parse(get_img.mail_img);
                    this.img_src = oSrc;
                } else {
                    alert(get_img.msg);
                    console.log(get_img.error);
                }
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    watch : {},
    beforeDestroy : function () {
        $('#datatable').DataTable({
            destroy: true
        });
    }
}
</script>

<style>
    
</style>